import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../utils/apiCalls';

export function useRoutePlan({ routePlanId, onSuccess = () => {} }) {
  const { data, ...rest } = useQuery(
    'routePlan',
    () => apiCalls.getRoutePlansV2({ routePlanId }).then(({ data: { routePlans } }) => routePlans[0]),
    {
      enabled: !!routePlanId,
      onSuccess: (data) => {
        onSuccess(data);
      },
    }
  );
  return { routePlan: data, ...rest };
}

export function useRoutePlans(params) {
  const { data, ...rest } = useQuery(
    ['routePlans', { deliveryDate: params.deliveryDate }],
    () =>
      apiCalls.getRoutePlansV2(params).then(({ data: { routePlans, totalCount } }) => ({
        routePlans,
        totalCount,
      })),
    {
      enabled: !!params.deliveryDate,
    }
  );
  return { result: data, ...rest };
}

export function useRoutePlanCreate(onSuccess) {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ routePlan }) => apiCalls.createRoutePlanV2({ routePlan }), {
    onSuccess: (routePlan) => {
      queryClient.invalidateQueries('routePlans');
      onSuccess(routePlan);
    },
  });
  return { createRoutePlan: mutate, ...rest };
}

export function useRoutePlanEdit(onSuccess) {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(
    ({ routePlan, ...other }) => apiCalls.editRoutePlanV2({ routePlan, ...other }),
    {
      onSuccess: (routePlan) => {
        queryClient.invalidateQueries('routePlans');
        queryClient.invalidateQueries('routePlan');
        queryClient.invalidateQueries('routes');
        onSuccess(routePlan);
      },
    }
  );
  return { editRoutePlan: mutate, ...rest };
}

export function useRoutePlanDelete() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(
    ({ routePlan }) => apiCalls.deleteRoutePlanV2({ routePlanId: routePlan.id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('routePlans');
      },
    }
  );
  return { deleteRoutePlan: mutate, ...rest };
}
